
import React, { Component } from 'react';
import 'react-day-picker/lib/style.css';
import XenioUpdatesService from '../Services/XenioUpdates/xenioUpdates';
import {  faPlusCircle,  faTrash, faExclamationTriangle, faEdit } from '../../node_modules/@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Modal, ModalHeader, ModalBody, ModalFooter, Badge } from 'reactstrap';
import { ToastContainer,toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { css } from 'react-emotion';
// First way to import
import { ClipLoader } from 'react-spinners';
import {  Redirect } from 'react-router-dom';
import MainLayout from '../layout/layout';
import RolesType from '../utils/roles';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;

class Version extends Component {

    constructor(props) {
        super();
        this.state = {
            VersionData: { DataPending: false, DataValue: [] },
            UpdatesList: { DataPending: false, value: [] },
            UpdateNameList: [],
            totalCount: 0,
            page: 1,
            maxPerPage: 10,
            divWidth: {
                width: 30000
            },
            className: "custom-dialog",
            Filter: {
                FilterUpdate: 0,
                FilterVersion: ""
            },
            SelectType: "",
            SelectVersionName: "",
            SelectUpdateID: 0,
            SelectUpdate: 0,
            Description: "",
            modal: { warning: false, id: null, success: false, add: false },
            Button: <a className="btn btn-success" >OK</a>,
            loading: false,
            UploadFileName: "Choose File",
            selectedFile: null,
            Edit: false,
            isAutenticated: true
        };
        this.hanldeKeyPress = this.hanldeKeyPress.bind(this);
        this.companyCodeValueV = this.companyCodeValueV.bind(this);
        this.toggleAdd = this.toggleAdd.bind(this);
        this.hanldeDescription = this.hanldeDescription.bind(this);
        this.hanldeUpdate = this.hanldeUpdate.bind(this);
        this.hanldeVersionName = this.hanldeVersionName.bind(this);    
        this.toggleWarning = this.toggleWarning.bind(this);  
        this.changeFileName = this.changeFileName.bind(this);
        this.hanldeUpdateList = this.hanldeUpdateList.bind(this);
    }
  
    hanldeKeyPress(e){
        var VersionName =this.state.Filter.FilterVersion;
        var UpdateID = this.state.Filter.FilterUpdate !== "" ? this.state.Filter.FilterUpdate : 0;

         if(e.keyCode === 13){    
             this.getAll(1, 10, VersionName, UpdateID );                  
         }
     }
    componentDidMount() {

        this.getUpdates();
        var updateID = this.state.Filter.FilterUpdate !== "" ? this.state.Filter.FilterUpdate : 0;
        this.getAll(this.state.page, this.state.maxPerPage, "", updateID)
                  
    }
    getAll(page, maxPerPage, VersionName, UpdateID) {

        this.setState({
            VersionData: { DataPending: true, DataValue: [] },
            totalCount: 0,
            page: 1
        });
        let dataResult = XenioUpdatesService.getAllVersions(page, maxPerPage, VersionName, UpdateID);

        var that = this;

        dataResult.then(function (data) {

            that.setState({
                VersionData: { DataPending: false, DataValue: data.data.Versions },
                totalCount: parseInt(data.data.Version_Total_Count, 10),
                page: data.data.npage
            });
        }).catch((error) => {

            that.setState({
                VersionData: { DataPending: false, DataValue: [] },
                totalCount: 0,
                page: 1
            });        
            if(error.response)
            {
                if(error && error.response && error.response.data.Message === "500") {               
                    toast.error("Error Data Base(Error: 500)", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data === "NoDB") {
                   toast.error("Company Code dosen't exist!", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data === "NotReseller") {    
                   toast.error("This User does not have permission!", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data.Message === "400"){ 
                   toast.error("API Error for Reseller", { className: {
                       opacity: 0.8
                   }});
                }else if(error.response.status === 401){ 
                       sessionStorage.setItem("user", '');
                       sessionStorage.setItem("token", '');
                       sessionStorage.setItem("rol", '');
                       sessionStorage.setItem("email", '');
                       sessionStorage.clear();  
                       this.setState({ isAutenticated: false },
                       ()=>{                               
                           this.forceUpdate();
                       })              
                }   
            }else{
                toast.error("Code Error", { className: {
                    opacity: 0.8
                }});
            }
        });            
    }
    hanldeVersionName(e){
        e.preventDefault();     
        let stateCopy = Object.assign({}, this.state);
        stateCopy.SelectVersionName = e.target.value;
        this.setState(stateCopy);
    }
    hanldeDescription(e){
        e.preventDefault();     
        let stateCopy = Object.assign({}, this.state);
        stateCopy.Description = e.target.value;
        this.setState(stateCopy);
    }
    hanldeUpdate(e){
        e.preventDefault();     
        let stateCopy = Object.assign({}, this.state);
        stateCopy.SelectUpdateID = e.target.value;
        stateCopy.Filter.FilterUpdate = e.target.value;
        this.setState(stateCopy);
    }

    hanldeUpdateList(e){

        var updateID = e.target.value !== "" ? e.target.value : 0;
        e.preventDefault();     
        let stateCopy = Object.assign({}, this.state);
        stateCopy.SelectUpdate = e.target.value;
        stateCopy.Filter.FilterUpdate = e.target.value;
        this.setState(stateCopy);

        this.getAll(1, 10, "", updateID)
    }
    toggleAdd() {

        this.setState({
            modal: { warning: false, id: null, success: false, add: !this.state.modal.add },
            SelectVersionName : "",
            SelectUpdateID: 0,
            Description: "",
            UploadFileName: "Choose File",
            Edit: false
        });
        //this.getUpdates();
    }
    toggleWarning(id) {

        this.setState({
            modal: { warning: !this.state.modal.warning, id: id, success: false, add: false }
        });
    }
    setOperationCompanyVersions(a, id, operations) {

        if(operations === "DELETE") {
            this.setState({
                Button: <a className="btn btn-warning" onClick={(e) => { this.DeleteUpdate(e, id) }}>OK</a>,
                loading: false
            });
            this.toggleWarning(id);
        }else if(operations === "ADD") {
            this.setState({
                Button: <a className="btn btn-success" onClick={(e) => { this.AddVersion(e) }}>OK</a>,
                loading: false
            });          
            this.toggleAdd();
        }else if(operations === "EDIT") {
            this.setState({
                loading: false
            });
            this.toggleEdit(id);
        }
    }
    toggleEdit(id) {

        var VersionList =  this.state.VersionData.DataValue;

        this.getUpdates(()=>{
            var UpdatesList =  this.state.UpdatesList.value;          
            var version = VersionList.find(x=>x.ID === id);
            var update =  UpdatesList.find(c=>c.NAME === version.UpdateName)

            this.setState({
                modal: { warning: false, success: false, add: !this.state.modal.add, id: id },
                SelectVersionName: version.VersionName,
                SelectUpdateID: update.ID,
                //FilterUpdate: update.ID,
                Description: version.Description,
                Edit: true
            }, ()=>console.log());        
        });   
    }
    getUpdates(callback){
        var DataResult = XenioUpdatesService.getAllUpdates();
        var that = this;
        DataResult.then(function (data) {
            that.setState({
                UpdatesList: { pending: false, value: data.data }
            },callback);
        })
    }
    AddVersion(e)
    {   
        e.preventDefault();
        var UpdateID = this.state.SelectUpdateID;
        var VersionName = this.state.SelectVersionName;
        var Description = this.state.Description; 
        var DataFile = this.state.selectedFile;
        var FileName = this.state.UploadFileName;
        var email = sessionStorage.getItem('email');
        var ID = this.state.modal.id;
        var Edit  = this.state.Edit;      

        var that = this;
        if(VersionName === "" || UpdateID === "" || UpdateID === 0  || DataFile === "" || DataFile === "Choose File" || DataFile === null)
        {
            toast.warning("VersionName, Update and APK can not be empty!", { className: {
                opacity: 0.8
            }});
        }else{
            if(Edit){
                var resultEdit = XenioUpdatesService.EditVersion(ID, VersionName, UpdateID, Description, FileName, DataFile, email);        
                that.setState({
                    loading: true,
                    Button: <a className="btn btn-success disabled" onClick={(e) => { this.AddVersion(e) }} >OK</a>,
                    
                });        
                resultEdit.then(function(data){        
                    if(data.data === "OK"){        
                        that.setState({
                            modal: { success : false, id:null, add : false},
                            Description: "",
                            SelectVersionName: "",
                            SelectUpdateID: 0,
                            FilterUpdate: 0,
                            selectedFile: "",
                            UploadFileName: "Choose File",
                            loading: false,
                            Edit: false
                        });        
                        that.getAll(1, 10, "", 0);        
                        toast.success("Saved!", { className: {
                            opacity: 0.8
                        }});
                    }else if(data.data === "NoExist"){        
                        that.setState({
                            loading: false
                        });        
                        toast.error("This Version dosen't exist!", { className: {
                            opacity: 0.8
                        }});
                    }else if(data.data === "No"){        
                        that.setState({
                            modal: { success : false, id:null, add: false},
                            SelectUpdateID : 0,
                            FilterUpdate: 0,
                            Description: "",
                            SelectVersionName: "",
                            selectedFile: "",
                            UploadFileName: "Choose File",
                            loading: false,
                            Edit: false
                        });                
                        toast.error("Not Saved!", { className: {
                            opacity: 0.8
                        }});
                    }else if(data.data.Message === "APK"){        
                        that.setState({
                            loading: false
                        });   
                        toast.error("File must be .APK!", { className: {
                            opacity: 0.8
                        }});
                    }else if(data.data === "AuditError"){        
                        that.setState({
                            modal: { success : false, id:null, add: false},
                            SelectUpdateID : 0,
                            FilterUpdate: 0,
                            Description: "",
                            SelectVersionName: "",
                            selectedFile: "",
                            UploadFileName: "Choose File",
                            loading: false,
                            Edit: false
                        });                
                        toast.error("Not Saved!", { className: {
                            opacity: 0.8
                        }});
                    }
                }).catch((error) => {        
                    that.setState({
                        modal: { success : false, id:null, add:false},
                        SelectUpdateID : 0,
                        FilterUpdate: 0,
                        Description: "",
                        SelectVersionName: "",
                        selectedFile: "",
                        UploadFileName: "Choose File",
                        loading: false,
                        Edit: false
                    });      
                    if(error.response)
                    {
                        if(error && error.response && error.response.data.Message === "500") {               
                            toast.error("Error Data Base(Error: 500)", { className: {
                               opacity: 0.8
                           }});
                       }else if(error && error.response && error.response.data === "NoDB") {
                           toast.error("Company Code dosen't exist!", { className: {
                               opacity: 0.8
                           }});
                       }else if(error && error.response && error.response.data === "NotReseller") {    
                           toast.error("This User does not have permission!", { className: {
                               opacity: 0.8
                           }});
                       }else if(error && error.response && error.response.data.Message === "400"){ 
                           toast.error("API Error for Reseller", { className: {
                               opacity: 0.8
                           }});
                        }else if(error.response.status === 401){ 
                               sessionStorage.setItem("user", '');
                               sessionStorage.setItem("token", '');
                               sessionStorage.setItem("rol", '');
                               sessionStorage.setItem("email", '');
                               sessionStorage.clear();  
                               this.setState({ isAutenticated: false },
                               ()=>{                               
                                   this.forceUpdate();
                               })              
                        }   
                    }else{
                        toast.error("Code Error", { className: {
                            opacity: 0.8
                        }});
                    }
                });     
            }else{
                var result = XenioUpdatesService.AddVersion(VersionName, UpdateID, Description, FileName, DataFile, email);
                that.setState({
                    loading: true,
                    UploadFileName: "Choose File"
                });        
                result.then(function(data){        
                    if(data.data === "OK"){        
                        that.setState({
                            modal: { success : false, id:null, add : false},
                            Description: "",
                            SelectVersionName: "",
                            SelectUpdateID: 0,
                            FilterUpdate: 0,
                            selectedFile: "",
                            UploadFileName: "Choose File",
                            loading: false
                        });        
                        that.getAll(1, 10, "", 0);        
                        toast.success("Saved!", { className: {
                            opacity: 0.8
                        }});
                    }else if(data.data === "Exist"){        
                        that.setState({
                            loading: false
                        });        
                        toast.error("This Version already exist!", { className: {
                            opacity: 0.8
                        }});
                    }else if(data.data === "No"){        
                        that.setState({
                            modal: { success : false, id:null, add:false},
                            SelectUpdateID : 0,
                            FilterUpdate: 0,
                            Description: "",
                            SelectVersionName: "",
                            selectedFile: "",
                            UploadFileName: "Choose File",
                            loading: false
                        });                
                        toast.error("Not Saved!", { className: {
                            opacity: 0.8
                        }});
                    }else if(data.data.Message === "APK"){        
                        that.setState({
                            loading: false
                        });                            
                        toast.error("File must be .APK!", { className: {
                            opacity: 0.8
                        }});
                    }else if(data.data === "AuditError"){        
                        that.setState({
                            modal: { success : false, id:null, add:false},
                            SelectUpdateID : 0,
                            FilterUpdate: 0,
                            Description: "",
                            SelectVersionName: "",
                            selectedFile: "",
                            UploadFileName: "Choose File",
                            loading: false
                        });                
                        toast.error("Not Saved!", { className: {
                            opacity: 0.8
                        }});
                    }
                }).catch((error) => {        
                    that.setState({
                        modal: { success : false, id:null, add:false},
                        SelectUpdateID : 0,
                        FilterUpdate: 0,
                        Description: "",
                        SelectVersionName: "",
                        selectedFile: "",
                        UploadFileName: "Choose File",
                        loading: false
                    });      
                    if(error.response)
                    {
                        if(error && error.response && error.response.data.Message === "500") {               
                            toast.error("Error Data Base(Error: 500)", { className: {
                               opacity: 0.8
                           }});
                       }else if(error && error.response && error.response.data === "NoDB") {
                           toast.error("Company Code dosen't exist!", { className: {
                               opacity: 0.8
                           }});
                       }else if(error && error.response && error.response.data === "NotReseller") {    
                           toast.error("This User does not have permission!", { className: {
                               opacity: 0.8
                           }});
                       }else if(error && error.response && error.response.data.Message === "400"){ 
                           toast.error("API Error for Reseller", { className: {
                               opacity: 0.8
                           }});
                        }else if(error.response.status === 401){ 
                               sessionStorage.setItem("user", '');
                               sessionStorage.setItem("token", '');
                               sessionStorage.setItem("rol", '');
                               sessionStorage.setItem("email", '');
                               sessionStorage.clear();  
                               this.setState({ isAutenticated: false },
                               ()=>{                               
                                   this.forceUpdate();
                               })              
                        }   
                    }else{
                        toast.error("Code Error", { className: {
                            opacity: 0.8
                        }});
                    }
                });     
            }
        } 
    }      
    DeleteUpdate(e, id){
        var email = sessionStorage.getItem('email');
        var result = XenioUpdatesService.DeleteUpdate(id, email);
        var that = this;
        that.setState({
            Button: <a className="btn btn-warning disabled" onClick={(e) => { this.DeleteUpdate(e, id) }} disabled>OK</a>,
            loading: true
        });
        result.then(function(data){
            if(data.data === "OK"){
                that.setState({
                    Button: <a className="btn btn-warning" onClick={(e) => { this.DeleteUpdate(e, id) }}>OK</a>,
                    modal: { success : false, id:null, add : false, warning: false},
                    loading: false
                });
                that.getAll(1, 10, "", 0);
                toast.success("Deleted!", { className: {
                    opacity: 0.8
                }});
            }else if(data.data === "Empty"){
                that.setState({
                    Button: <a className="btn btn-warning" onClick={(e) => { this.DeleteUpdate(e, id) }} >OK</a>,
                    modal: { success : false, id:null, add : false, warning: false},
                    loading: false
                });
                //that.SearchCompanyVersionByCompanyCode(CompanyCode.CompanyCode);
                toast.error("Not Exist!", { className: {
                    opacity: 0.8
                }});
            }else if(data.data === "No"){
                that.setState({
                    Button: <a className="btn btn-warning " onClick={(e) => { this.DeleteUpdate(e, id) }} >OK</a>,
                    modal: { success : false, id:null,  warning: false, add: false},
                    loading: false
                });                
                toast.error("Not Deleted!", { className: {
                    opacity: 0.8
                }});
            }else if(data.data === "AuditError"){
                that.setState({
                    Button: <a className="btn btn-warning " onClick={(e) => { this.DeleteUpdate(e, id) }} >OK</a>,
                    modal: { success : false, id:null,  warning: false, add: false},
                    loading: false
                });         
                toast.error("Not Deleted!", { className: {
                    opacity: 0.8
                }});
            }
        }).catch((error) => {
        
            that.setState({
                Button: <a className="btn btn-warning " onClick={(e) => { this.DeleteUpdate(e, id) }} >OK</a>,
                modal: { success : false, id:null,  warning: false, add: false},
                loading: false
            });      
            if(error.response)
            {
                if(error && error.response && error.response.data.Message === "500") {               
                    toast.error("Error Data Base(Error: 500)", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data === "NoDB") {
                   toast.error("Company Code dosen't exist!", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data === "NotReseller") {    
                   toast.error("This User does not have permission!", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data.Message === "400"){ 
                   toast.error("API Error for Reseller", { className: {
                       opacity: 0.8
                   }});
                }else if(error.response.status === 401){ 
                       sessionStorage.setItem("user", '');
                       sessionStorage.setItem("token", '');
                       sessionStorage.setItem("rol", '');
                       sessionStorage.setItem("email", '');
                       sessionStorage.clear();  
                       this.setState({ isAutenticated: false },
                       ()=>{                               
                           this.forceUpdate();
                       })              
                }   
            }else{
                toast.error("Code Error", { className: {
                    opacity: 0.8
                }});
            } 
        });          
    }
    changeFileName(e){
     
        var uploadedFile = e.target.files[0];
        var name = e.target.files[0] ?  e.target.files[0].name : "Choose File";

        if(uploadedFile){
            let reader = new FileReader();
            reader.onload = (progressEvent) => {
                let target = progressEvent.target; 
                let result = target.result;
                var data = result.split(',').pop();    
                this.setState({
                    UploadFileName: name,
                    selectedFile: data  
                });              
            };    
            reader.readAsDataURL(uploadedFile);   
        }else{
            this.setState({
                UploadFileName: "Choose File",
                selectedFile: ""  
            });  
        }   
    }
    companyCodeValueV(e) {
        e.preventDefault();       
        let stateCopy = Object.assign({}, this.state);
        stateCopy.Filter.FilterVersion = e.target.value;
        this.setState(stateCopy);
    }
    renderPages() {
        let pages = [];
        let pagesCount = parseInt(this.getPagesCount(this.state.maxPerPage), 10);
        let pagesShow = pagesCount > 5 ? 5 : this.getPagesCount(this.state.maxPerPage);
        let startPagination = pagesCount <= 5 ? 1 : (this.state.page - 3 <= 0 ? 1 : (this.state.page + 2 > pagesCount ? pagesCount - 4 : this.state.page - 2));
        for (let i = startPagination; i <= startPagination + pagesShow - 1; i++) {
            pages.push(<li key={i} className={this.state.page === i ? "page-item active" : "page-item"} onClick={(event) => {
                event.preventDefault(); this.getAll(i, this.state.maxPerPage, this.state.Filter.FilterVersion, this.state.Filter.FilterUpdate)
            }}><a className="page-link">{i}</a></li>);
        }
        return pages
    }
    renderNextPage() {
        let next_page = this.getNextPage(this.state.page, this.state.maxPerPage);
        let pagesCount = parseInt(this.getPagesCount(this.state.maxPerPage), 10);
        let nextpages = [];
        if (next_page !== 0) {
            nextpages.push(<li key="Next" className="page-item" onClick={(event) => {
                event.preventDefault(); this.getAll(next_page, this.state.maxPerPage, this.state.Filter.FilterVersion, this.state.Filter.FilterUpdate)
            }}>
                <a className="page-link" aria-label="Next">
                    <span aria-hidden="true">&raquo;</span>
                </a>
            </li>);
            nextpages.push(<li key="Last" className="page-item" onClick={(event) => {
                event.preventDefault(); this.getAll(pagesCount, this.state.maxPerPage, this.state.Filter.FilterVersion, this.state.Filter.FilterUpdate)
            }}>
                <a className="page-link" aria-label="Last">
                    <span aria-hidden="true">Last</span>
                </a>
            </li>);
        }else {
            nextpages.push(<li key="NextP" className="page-item disabled">
                <a className="page-link" aria-label="Next">
                    <span aria-hidden="true">&raquo;</span>
                </a>
            </li>);
            nextpages.push(<li key="LastP" className="page-item disabled">
                <a className="page-link" aria-label="Last">
                    <span aria-hidden="true">Last</span>
                </a>
            </li>);
        }
        return nextpages;
    }
    renderFirstPage() {
        let prev_page = this.getPrevPage(this.state.page, this.state.maxPerPage);
        let prevpages = [];
        if (prev_page !== 0) {
            prevpages.push(<li key="FirstT" className="page-item" onClick={(event) => {
                event.preventDefault(); this.getAll(1, this.state.maxPerPage, this.state.Filter.FilterVersion, this.state.Filter.FilterUpdate)
            }}>
                <a className="page-link" aria-label="First">
                    <span aria-hidden="true">First</span>
                </a>
            </li>);
            prevpages.push(<li key="FirstTT" className="page-item" onClick={(event) => {
                event.preventDefault(); this.getAll(prev_page, this.state.maxPerPage, this.state.Filter.FilterVersion, this.state.Filter.FilterUpdate)
            }}>
                <a className="page-link" aria-label="Previous">
                    <span aria-hidden="true">&laquo;</span>
                </a>
            </li>);
        }else {
            prevpages.push(<li key="FirstPP" className="page-item disabled">
                <a className="page-link" aria-label="First">
                    <span aria-hidden="true">First</span>
                </a>
            </li>);
            prevpages.push(<li key="FirstPPP" className="page-item disabled">
                <a className="page-link" aria-label="Previous">
                    <span aria-hidden="true">&laquo;</span>
                </a>
            </li>);
        }
        return prevpages;
    }
    getPrevPage(currentPage, maxPerPage) {
        if (parseInt(maxPerPage >= this.state.totalCount, 10))
            return 0;
        else
            return currentPage - 1;
    }
    getNextPage(currentPage, maxPerPage) {
        if ( parseInt( this.state.totalCount / maxPerPage, 10) === currentPage && parseInt(this.state.totalCount % maxPerPage, 10) === 0)
            return 0;
        else if ( parseInt(this.state.totalCount / maxPerPage, 10) === currentPage - 1 && parseInt(this.state.totalCount % maxPerPage, 10) > 0)
            return 0;
        else
            return currentPage + 1;
    }
    getPagesCount(maxPerPage) {
        if (parseInt(this.state.totalCount % maxPerPage, 10) > 0)
            return (this.state.totalCount / maxPerPage) + 1;
        else
            return this.state.totalCount / maxPerPage;
    }
    renderCompanyVersionRow(){
        let dataResult = RolesType;
        var temp = Object.keys(dataResult);
        let optionItemsUpdates1= this.state.UpdatesList.value.map((item, index) => {
            return <option key={item.ID} className="dropdown-item" href="#" value={item.ID}>{item.NAME}</option>
        });
        if(sessionStorage.getItem("rol") === temp[0] || sessionStorage.getItem("rol") === temp[1] || sessionStorage.getItem("rol") === temp[2])
        {
            return  <div>
                        <div className="row">
                        <div className="col s12">
                            <div className="card Logs">
                                <div className="card-header">
                                    <div className="row" id="timelogs_filter">
                                        {/* <div className="col-3">                 
                                            <h4><span className="badge badge-info">Versions</span></h4>                             
                                        </div> */}
                                        <div className="col-lg-2 col-md-2 col-sm-2">
                                            <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Version Name</label>
                                        </div>
                                        <div className="col-lg-3 col-md-3 col-sm-3">
                                            <div className="form-group" style={{ 'paddingTop': '7px' }}>
                                                <input className="form-control" name="VName" id="VName" type="text" onKeyDown={this.hanldeKeyPress} onChange={this.companyCodeValueV} value={this.state.Filter.SelectVersionName} />
                                            </div>
                                        </div>
                                        <div className="col-lg-1 col-md-1 col-sm-1">
                                             <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Type</label>
                                        </div>
                                        <div className="col-lg-2 col-md-2 col-sm-2" style={{ 'paddingTop': '7px' }}>                                           
                                            <select className="form-control" onChange={this.hanldeUpdateList} value={this.state.Filter.FilterUpdate}>
                                                <option className="dropdown-item" href="#" value="0" >Select</option>
                                                { optionItemsUpdates1 }
                                            </select>
                                        </div>
                                        <div className="col-lg-3 col-md-3 col-sm-3">
                                            <div className="form-group">
                                                {/* <Button color="info" style={{ 'padding': '0.6rem 1.14rem' }} onClick={this.SearchCompanyVersion}  ><FontAwesomeIcon icon={faSearch} />&nbsp;&nbsp;Search</Button> */}
                                                <a className="btn btn-success" style={{ 'padding': '0.6rem 1.14rem' }} onClick={(e) => this.setOperationCompanyVersions(e, "", 'ADD')}><FontAwesomeIcon icon={faPlusCircle} />&nbsp;&nbsp;Create</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <table className="table table-hover table-striped table-sm  myTable">
                                        <thead>
                                            <tr>
                                                <th scope="col" style={{'fontWeight': 'bold'}}>ID</th>
                                                <th scope="col" style={{'fontWeight': 'bold'}}>Version Name</th>
                                                <th scope="col" style={{'fontWeight': 'bold'}}>Type</th>
                                                <th scope="col" style={{'fontWeight': 'bold'}}>Description</th>
                                                <th scope="col" style={{'fontWeight': 'bold'}}></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                this.state.VersionData.DataValue.length > 0 
                                                ?
                                                this.state.VersionData.DataValue.map((item, index) => {
                                                    return <tr key={index}>
                                                        <td style={{'fontWeight': 'normal'}}>{item.ID}</td>
                                                        <td style={{'fontWeight': 'normal'}}>{item.VersionName}</td>
                                                        <td style={{'fontWeight': 'normal'}}>{item.UpdateName}</td>
                                                        <td style={{'fontWeight': 'normal'}}>{item.Description}</td>
                                                        <td>
                                                            <h6>
                                                                <a title="Edit User"  onClick={(e)=>{this.setOperationCompanyVersions(e, item.ID,"EDIT")}}><Badge color="warning"><FontAwesomeIcon  icon={faEdit} /></Badge></a>&nbsp;&nbsp;
                                                                <a title="Delete User"  onClick={(e)=>{this.setOperationCompanyVersions(e, item.ID,"DELETE")}}><Badge color="danger"><FontAwesomeIcon  icon={faTrash} /></Badge></a>
                                                            </h6>
                                                        </td>
                                                    </tr>;
                                                })
                                                :
                                                <tr><td colSpan="13"><div style={{ 'textAlign': 'center', 'fontWeight': 'normal' }}>No records.</div></td></tr>
                                            }
                                        </tbody>
                                    </table>
                                    <nav aria-label="Page navigation example">
                                        <ul className="pagination">
                                            {this.renderFirstPage()}
                                            {this.renderPages()}
                                            {this.renderNextPage()}
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> 
        }
    }
    render() {

        if (!this.state.isAutenticated) {
            return (<Redirect to={'/login'}/>)
        }
        let optionItemsUpdates= this.state.UpdatesList.value.map((item, index) => {
            return <option key={item.ID} className="dropdown-item" href="#" value={item.ID}>{item.NAME}</option>
        });

        return (
            <div className="">
            <BlockUi tag="div" blocking={this.state.VersionData.DataPending} loader={ <div className="loader"></div>} >    
            <MainLayout/>
                <div className="container"><ToastContainer hideProgressBar/>
               {
                   this.renderCompanyVersionRow()
               }
                    <Modal isOpen={this.state.modal.add} toggle={this.toggleAdd}
                        aria-labelledby="contained-modal-title-lg"
                        className={"modal-dialog modal-notify modal-success"}
                    >
                        <ModalHeader toggle={this.toggle}> <p className="heading lead">ADD</p>
                        </ModalHeader>
                        <ModalBody className={"text-center"} style={{ 'maxHeight': 'calc(100vh - 210px)', 'overflowY': 'auto' }}>
                            <div className="row" >
                                <div className="col-lg-4 col-md-4 col-sm-4">
                                    <label className="control-label" style={{ 'paddingTop': '15px', 'float': 'right', 'fontWeight': 'bold' }}>Version Name</label>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-6">
                                    <div className="form-group" style={{ 'paddingTop': '7px' }}>
                                        <input className="form-control" name="SelectVersionName" id="SelectVersionName" type="text" onChange={this.hanldeVersionName} value={this.state.SelectVersionName} disabled={this.state.Edit}/>
                                    </div>
                                </div>
                            </div>
                            <div className="row" >
                                <div className="col-lg-4 col-md-4 col-sm-4">
                                    <label className="control-label" style={{ 'paddingTop': '15px', 'float': 'right' , 'fontWeight': 'bold'}}>Type</label>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-6">
                                    <select className="form-control" onChange={this.hanldeUpdate} value={this.state.SelectUpdateID}>
                                        <option className="dropdown-item" href="#" value="" >Select</option>
                                        { optionItemsUpdates }
                                    </select>
                                </div>
                            </div>
                            <div className="row" >
                                <div className="col-lg-4 col-md-4 col-sm-4">
                                    <label className="control-label" style={{ 'paddingTop': '15px', 'float': 'right', 'fontWeight': 'bold' }}>Description</label>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-6" >
                                     <textarea rows="4" cols="50" className="form-control" name="Description" id="Description" type="text" onChange={this.hanldeDescription} value={this.state.Description ? this.state.Description : ""} />
                                </div>
                            </div>
                            <div className="row" >
                                <div className="col-lg-4 col-md-4 col-sm-4">
                                    <label className="control-label" style={{ 'paddingTop': '15px', 'float': 'right' , 'fontWeight': 'bold'}}>Upload APK</label>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-6" >
                                    <div className="upload-btn-wrapper">
                                        <button style={{ 'width' : '100%', 'backgroundColor': '#00C851', 'marginLeft': '0px'}} onClick={(e)=>this.fileInput.click(e)}  className="btn">{this.state.UploadFileName}</button>
                                        <input ref={input =>this.fileInput = input } type="file" name="myfile" style={{'display': 'none'}}  onChange={ (event)=>{this.changeFileName(event)}}/>
                                    </div>                            
                                </div>
                            </div>
                        </ModalBody>
                        <ModalFooter className={"modal-footer justify-content-right"}>
                        <ClipLoader
                            className={override}
                            sizeUnit={"px"}
                            size={30}
                            color={'#00C851'}
                            loading={this.state.loading}
                        />
                               {                                   
                                    this.state.loading
                                    ? <div><a className="btn btn-success disabled" onClick={(e) => { this.AddVersion(e) }} disabled>OK</a>
                                        <a className="btn btn-outline-success waves-effect disabled" onClick={this.toggleAdd } disabled>CLOSE</a>
                                    </div>
                                    : <div><a className="btn btn-success" onClick={(e) => { this.AddVersion(e) }} >OK</a>
                                        <a className="btn btn-outline-success waves-effect" onClick={this.toggleAdd } >CLOSE</a>
                                    </div> 
                               }
                        </ModalFooter>
                    </Modal>

                    <Modal isOpen={this.state.modal.warning} toggle={this.toggleWarning}
                        aria-labelledby="contained-modal-title-lg"
                        className={"modal-dialog modal-notify modal-warning"}
                     >
                   <ModalHeader toggle={this.toggle}> <p className="heading lead">Warning</p>
                       </ModalHeader>
                   <ModalBody className={"text-center"} style={{ 'maxHeight': 'calc(100vh - 210px)', 'overflowY': 'auto' }}>
                         <p><FontAwesomeIcon color="#FFBB33"  icon={faExclamationTriangle} size="3x" /></p>
                         <p>Are you sure?</p>
                   </ModalBody>
                   <ModalFooter className={"modal-footer justify-content-right"}>
                   <ClipLoader
                        className={override}
                        sizeUnit={"px"}
                        size={30}
                        color={'#FF8800'}
                        loading={this.state.loading}
                    />
                       { this.state.Button }
                       {
                            this.state.loading
                            ? 
                            <div>
                                <a className="btn btn-outline-warning waves-effect disabled" onClick={this.toggleWarning } disabled>CLOSE</a>
                            </div>
                            : 
                            <div>
                                <a className="btn btn-outline-warning waves-effect" onClick={this.toggleWarning }>CLOSE</a>
                            </div>
                       }
                   </ModalFooter>
               </Modal>
                </div>
                </BlockUi>
            </div>
        );
    }
}
export default Version;



// WEBPACK FOOTER //
// ./src/version/version.jsx